import React from "react";
import { useNavigate } from "react-router-dom";
import  { useState, useEffect } from "react";
import "../css/customer.css";
import { fetchClients } from '../api/api';

const CustomerList = () => {
    const navigate = useNavigate();
   const [customers, setCustomers] = useState([]); 

  useEffect(() => {
    const getClients = async () => {
      try {
        const data = await fetchClients(); 
        setCustomers(data);               
      } catch (err) {
        console.error("Failed to fetch clients:", err);
      }
    };

    getClients();
  }, []);

  //edit clients
  const handleEdit = (customerId) => {
    navigate(`/add-customer?id=${customerId}`);
  };

  return (
    <div className="customer-content">
      <div className="header">
        <h2 className="page-title">Customer List</h2>
        
      </div>

      <div className="customer-card-container">
        {customers.length === 0 && <p>No customers found.</p>}

        {customers.map((customer, index) => (
          <div className="customer-card" key={index}>
            <div className="card-row">
              <strong>Customer Name:</strong>
              <span>{customer.name}</span>
            </div>
            <div className="card-row">
              <strong>Email:</strong>
              <span>{customer.email}</span>
            </div>
            <div className="card-row">
              <strong>Password:</strong>
              <span>{customer.password}</span>
            </div>
            <div className="card-row">
              <strong>DB Host:</strong>
              <span>{customer.db_host}</span>
            </div>
            <div className="card-row">
              <strong>DB Name:</strong>
              <span>{customer.db_name}</span>
            </div>
            <div className="card-row">
  <strong>Client Code:</strong>
  <span className="masked-text">
    {"•".repeat(customer.client_code?.length || 0)}
  </span>
</div>


          {/* edit button */}
          <div className="card-row">
            <button className="edit-btn" onClick={() => handleEdit(customer.id)}>
              Edit
            </button>
            </div>
          {/* edit button ends here */}

          </div>
        ))}
      </div>

    </div>
  );
};

export default CustomerList;
